import React, { useEffect } from 'react'
import styled from 'styled-components'
import Amplitude from '../../utils/amplitudeHelper'
import { useAutoMute } from '../../utils/useAutoMute'
import { fixedAssets, mobileAssets } from 'src/containers/PreCache'
import config from 'src/config'
import { useDispatch } from 'react-redux'
import { showGlobalModal } from 'src/ducks/layout'
import { GlobalModalTypes } from 'src/components/GlobalModals/GlobalModalContainer'
// import MobileNotice from '../MobileLobby/MobileNotice'
import { useHistory } from 'react-router'
import routes from 'src/routes'
import NoticeBar from 'src/components/NoticeBar'
import { useAuditoriumController } from 'src/utils/useAuditoriumController'
import MobileLayout from '../MobileLayout'
import ChatSection from 'src/components/ChatSection'

const MobileAuditorium = ({ currentUser }) => {
  useAutoMute()
  const hasAuditoriumAccess = useAuditoriumController(currentUser)
  const dispatch = useDispatch()
  const history = useHistory()

  useEffect(() => {
    document.title = `${config.eventName} | Auditorium`
    Amplitude.visit(`Auditorium`)
  }, [])

  if (!hasAuditoriumAccess) {
    return <>Loading...</>
  }

  return (
    <MobileLayout title="Virtual Hall" route="/lobby" noticeBar>
      <div>
        {!config.HALL_VIDEO_URL ? (
          <>
            <div
              style={{
                width: '100%',
                height: '220px',
                backgroundColor: '#000',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                color: '#fff',
                fontSize: '18px',
                textAlign: 'center',
                padding: '0 10px',
              }}
            ></div>
          </>
        ) : (
          <>
            <iframe
              title="auditorium-stream-mobile"
              id="1b1f6ca6-faef-317f-74bf-a4ce68f8e2d6-live-507a30e6-8cf4-adb9-bbb4-5711d8ba79da"
              src={config.HALL_VIDEO_URL}
              width="100%"
              height="220px"
              frameBorder="0"
              scrolling="no"
              allow="autoplay;encrypted-media;fullscreen"
              allowFullscreen
              webkitAllowFullscreen
              mozAllowFullscreen
              oAllowFullscreen
              msAllowFullscreen
            ></iframe>
          </>
        )}

        <div className="button-container">
          {/* <div className="theme-btn" onClick={() => dispatch(showGlobalModal(GlobalModalTypes.Agenda))}>
            Programme
          </div>
          <div className="theme-btn" onClick={() => dispatch(showGlobalModal(GlobalModalTypes.Speakers))}>
            Speakers
          </div> */}
        </div>
      </div>
      <div>
        <ChatSection currentUser={currentUser} />
      </div>
    </MobileLayout>
  )
}

const Page = styled.div`
  background-color: #f8c605;
  background-repeat: no-repeat;
  background-position: top center;
  @media (max-width: 1200px), (min-height: 1000px) {
    background-size: cover;
  }
  @media (min-width: 1201px) and (max-width: 2400px), screen and (min-height: 1000px) {
    background-size: 200%;
  }
  background-image: url(${mobileAssets.dashboardBg});
  background-size: cover;

  height: calc(100% - 50px);
  width: 100vw;
  overflow-y: scroll;
  position: absolute;

  .outer-wrapper {
    width: 100%;
  }

  .container {
    width: 98%;
    margin: auto;
    margin-top: 4%;
  }

  .screen-container {
    width: 100%;
    height: 220px;
    position: relative;
  }

  .video-container {
    width: 98%;
    height: 100%;
    background: #1e1e1e;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50.5%, -51%);

    iframe,
    video {
      height: 100%;
      width: 100%;
    }
  }

  .button-container {
    text-align: center;
    display: flex;
    justify-content: center;
    margin: 1rem 0;

    div {
      text-transform: uppercase;
      background: #000000;
      padding: 4px 1rem;
      width: 150px;
      display: flex;
      align-items: center;
      justify-content: center;
      text-decoration: none;
      font-weight: 600;
      font-size: 14px;
      border: 2px solid #fff;

      &:hover {
        color: #fff;
        transform: scale(1.1);
      }
    }
  }
  .masthead img {
    width: 100%;
    height: auto;
  }
  .chat-container {
    width: 100%;
    height: 600px;
    margin-top: 12px;
  }

  .organizer-header {
    background: #fff;
    display: inline-flex;
    align-items: center;
    padding: 9px;
    gap: 1rem;
    border-bottom-right-radius: 10px;
    margin-bottom: 1rem;

    p {
      margin: 0;
      font-size: 8px;
      font-weight: 500;
      letter-spacing: 0.24px;
    }

    img {
      max-width: 106px;
    }
  }

  .back button {
    font-size: 20px;
    color: var(--yellow);
    outline: 0;
    border: 0;
    background: transparent;
    margin-bottom: 10px;
  }

  .controls {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin: 1rem 0;
    gap: 2rem;

    button {
      background: var(--gradient-yellow);
      color: var(--light-blue-900);
      border: 0;
      outline: 0;
      padding: 6px 25px;
      border-radius: 30px;
      font-size: 16px;
      font-family: 'DIN';
      font-weight: 700;
    }
  }

  @media screen and (min-width: 540px) {
    .outer-wrapper {
      width: 540px;
      margin: auto;
    }
  }
`

export default MobileAuditorium
